import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=c0667434&scoped=true&lang=pug"
import script from "./Reservations.vue?vue&type=script&lang=ts"
export * from "./Reservations.vue?vue&type=script&lang=ts"
import style0 from "./Reservations.vue?vue&type=style&index=0&id=c0667434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0667434",
  null
  
)

export default component.exports